
import React, { useEffect, useState, useRef, useCallback } from "react";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import styles from "../battery/Battery.module.scss";
import cn from "classnames";
import { getRequest, postRequest } from "services/axiosBaseClient";
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import LocalStorageService from "services/tokenlocalstorage.service";



const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#f5f5ff",
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: "#ffffff",
    },
  },
}))(TableRow);

function createData(hourCount, weekCount, monthCount, quarterCount) {
  return { hourCount, weekCount, monthCount, quarterCount };
}

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
});

export default function BatteryFaultListing(props) {
  const [revenue,setRevenue ] = useState([]);
  const row = [
    createData(revenue.hourCount,revenue.weekCount,revenue.monthCount,revenue.quarterCount),
  ];
  const classes = useStyles();
  const getRevenueList = useCallback(async () => {
    const headerFilterObj = JSON.parse(
      LocalStorageService.get("headerFilter")
    );
    var query =
      (headerFilterObj?.stateId === undefined ||
        headerFilterObj?.stateId === ""
        ? ""
        : "&stateId=" + headerFilterObj.stateId) +
      (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
        ? ""
        : "&cityId=" + headerFilterObj.cityId) +
      (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
        ? ""
        : "&zoneId=" + headerFilterObj.zoneId);
    await getRequest("bss/reportsBatteryFaultListing?" + query)
      .then((res) => {
        console.log(res?.data, "<---------------------");
        if (res && res?.data) {
          setRevenue(res.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);
  useEffect(() => {
    getRevenueList();
  }, [props.headerFilter]);


  const columns = [
    { title: "24Hrs", field: "hourCount", },
    { title: "1Week", field: "weekCount", },
    { title: "1Month", field: "monthCount", type: "numeric" },
    { title: "3Month", field: 'quarterCount', }]
  const downloadPdf = () => {
    const doc = new jsPDF()
    doc.text("Battery Fault Listing", 20, 10)
    doc.autoTable({
      theme: "grid",
      columns: columns.map(col => ({ ...col, dataKey: col.field })),
      body: row
    })
    doc.save('table.pdf')
  }

  return (
    <div
    styles={{ backgroundColor: "#FFFFFF"}}
    className={cn(styles.block25, styles.block25_layout)}
  >
    <TableContainer component={Paper} style={{padding:"20px"}}>
      <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"20px" }}>
      <h2 style={{ fontSize:"15px"}} className={cn(styles.medium_title, styles.medium_title_layout)}>
        { "Battery Fault Listing"}
      </h2>
      <button onClick={downloadPdf} style={{display:"inline-block",float:"right", margin:"0px", padding: "8px 15px" ,color:"white" ,backgroundColor:"#23297A",borderRadius:"5px"}} >
                <img
                  src={require("assets/downloadbtn.svg").default}
                  alt="e"
                  style={{ color: "white" ,paddingRight:"6px"}}
                />
                  Download
                </button>
      </div>
       
      <Table className={classes.table} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>24 Hrs</StyledTableCell>
            <StyledTableCell >1 Week</StyledTableCell>
            <StyledTableCell >1 Month</StyledTableCell>
            <StyledTableCell >3 Months</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {row.map((row) => (
            <StyledTableRow key={row.hourCount}>
              <StyledTableCell component="th" scope="swap">{row.hourCount} </StyledTableCell>
              <StyledTableCell>{row.weekCount} </StyledTableCell>
              <StyledTableCell >{row.monthCount} </StyledTableCell>
              <StyledTableCell >{row.quarterCount} </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </div>
  );
}
